import { z } from 'zod';

export const dashboardSearchSchema = z.object({
    adviserAbsence: z.literal(true).optional().catch(undefined),
});
